import type { ReactNode } from 'react';

interface IProps {
    className: string;
    content: ReactNode;
}

// Language-table entries may carry markup, so a string is injected as HTML.
const Label = ({ className, content }: IProps) =>
    typeof content === 'string' ? (
        <div className={className} dangerouslySetInnerHTML={{ __html: content }} />
    ) : (
        <div className={className}>{content}</div>
    );

export default Label;
